var App = App || {};

App.CatalystLayers = (function () {
    'use strict';

    function init() {

        const catalystLayers = $(".catalyst-layers");
        const catalystLayersGraphics = [

            { anchor: $(".masthead.home .masthead-content"), graphic: "masthead-home-content-circle" },
            { anchor: $(".masthead.home .masthead-promo-cards"), graphic: "masthead-home-cards-circle" },

            { anchor: $(".masthead.default.columns .masthead-content"), graphic: "masthead-columns-circle" },
            { anchor: $(".masthead.default.columns"), graphic: "masthead-columns-line-right" },

            { anchor: $(".masthead.default.centered:not(.long-title) .masthead-content"), graphic: "masthead-centered-circle" },
            { anchor: $(".masthead.default.centered .masthead-title"), graphic: "masthead-centered-line-left" },

            { anchor: $(".masthead.default.centered.long-title"), graphic: "masthead-centered-line-top" },
            { anchor: $(".masthead.default.centered.long-title .masthead-primary"), graphic: "masthead-centered-line-right" },

            { anchor: $(".masthead.default .masthead-features"), graphic: "masthead-features-line" },

            { anchor: $(".blog-header .blog-header-title"), graphic: "masthead-centered-circle" },
            { anchor: $(".blog-header .blog-header-title"), graphic: "masthead-centered-line-left" },

            { anchor: $(".blog-post .blog-post-masthead-primary"), graphic: "masthead-centered-line-top" },
            { anchor: $(".blog-post .blog-post-masthead-primary"), graphic: "masthead-centered-line-right" },
            { anchor: $(".blog-post .blog-post-masthead-primary"), graphic: "masthead-centered-line-left" },

            { anchor: $(".component-promo-image").next(".component-promo-image"), graphic: "promos-consecutive-circle" }
        ];

        catalystLayersGraphics.forEach((bg) => {
            if (bg.anchor.length > 0) {
                catalystLayers.prepend(`<div class=\"catalyst-layers-graphic ${bg.graphic}\" />`);
                const top = bg.anchor.offset().top - catalystLayers.offset().top + bg.anchor.height() / 2;
                catalystLayers.find(`.catalyst-layers-graphic.${bg.graphic}`).css({
                    top: top
                });
            }
        });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.CatalystLayers.init();
});